export default __webpack_public_path__ + "static/media/641c2d03d9413dd880a5cecd3bf4e2ee.svg";